var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tab-header"},_vm._l((_vm.tabs),function(tab,index){return _c('labelc',{key:tab.label,class:{
      onlyAdmin: tab.onlyAdmin,
      selected: tab === _vm.tabSelected,
      margin: tab.margin,
      hidden: _vm.IsHidden(tab),
    },style:({ width: (tab.width ? tab.width : 150) + 'px' }),attrs:{"icon-left":tab.onlyAdmin ? { icon: 'fa-user-shield' } : null,"type":"tab centered no-break","text":tab.label},on:{"click":function($event){return _vm.TabSelect(tab)}}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }